module.exports = __webpack_public_path__ + "static/media/plusScale.feb59f1c.svg";